import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';

import { authInterceptor } from './core/auth/auth.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    // Must be in the client config so the browser can hydrate server-rendered HTML.
    // Placing it only in app.config.server.ts means the browser bootstraps without
    // hydration support → silent error → shimmer skeleton never replaced.
    provideClientHydration(withEventReplay()),
    provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
    ),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    // Do not prefetch /user/dashboard here. An early 401 clears the JWT before the
    // router finishes, so a hard refresh on /dashboard looked like "random logout".
    // Credits load from dashboard shell (DashboardDataService.refresh) + login/onboarding.
  ],
};
